export function getStoryAuthor(story: { author?: string; author_data?: unknown }): string {
  const author = story.author?.trim();
  if (author) {
    return author;
  }
  const data = story.author_data;
  return data && typeof data === 'object' && 'name' in data && typeof data.name === 'string' ? data.name.trim() : '';
}
